import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../utils/functions";

const RETURN_FLAG = "returnToGis";
const LAST_REDIRECT = "gisLaunchAt";
const REPEAT_WINDOW_MS = 15000;

// Nginx sends visitors of the GIS site without a session here. This page gets them a
// ticket and returns them to GIS, or sends them to log in first and comes back after.
const GisLaunch = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const startedRef = useRef(false);
  const [error, setError] = useState("");

  const openGis = async () => {
    setError("");
    sessionStorage.setItem(RETURN_FLAG, "1");

    if (!localStorage.getItem("token")) {
      navigate("/login", { replace: true });
      return;
    }

    // coming straight back means the GIS session did not stick (e.g. cookies are blocked),
    // so stop here instead of bouncing between the two sites forever
    const lastRedirect = Number(sessionStorage.getItem(LAST_REDIRECT) || 0);
    if (Date.now() - lastRedirect < REPEAT_WINDOW_MS) {
      sessionStorage.removeItem(RETURN_FLAG);
      setError("The GIS Dashboard could not start your session. Please make sure cookies are allowed for this browser and try again.");
      return;
    }

    try {
      const response = await fetchData("gis/launch", "POST", {}, {}, {}, navigate, null, dispatch);
      // no response means fetchData logged the user out and went to the login page
      if (!response) return;
      if (!response.data?.url) throw new Error("No GIS address returned");
      sessionStorage.removeItem(RETURN_FLAG);
      sessionStorage.setItem(LAST_REDIRECT, String(Date.now()));
      window.location.replace(response.data.url);
    } catch (err) {
      // a 401/403 also logs out and goes to login; the flag brings the user back afterwards
      if (!localStorage.getItem("token")) return;
      sessionStorage.removeItem(RETURN_FLAG);
      setError(err?.message || "Could not open the GIS Dashboard.");
    }
  };

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    openGis();
  }, []);

  const tryAgain = () => {
    sessionStorage.removeItem(LAST_REDIRECT);
    openGis();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white text-center px-4">
      {error ? (
        <>
          <div className="border border-red-300 rounded-md p-4 bg-red-50 shadow-md text-red-500 text-sm max-w-lg">
            {error}
          </div>
          <div className="mt-6 flex gap-3">
            <button
              onClick={tryAgain}
              className="border border-red-400 text-red-400 hover:bg-red-50 transition px-6 py-2 rounded-full text-sm font-medium"
            >
              Try Again
            </button>
            <button
              onClick={() => navigate("/", { replace: true })}
              className="border border-gray-400 text-gray-600 hover:bg-gray-50 transition px-6 py-2 rounded-full text-sm font-medium"
            >
              Go to PAIDAR
            </button>
          </div>
        </>
      ) : (
        <p className="text-gray-600 text-sm">Opening the GIS Dashboard...</p>
      )}
    </div>
  );
};

export default GisLaunch;
